var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('standard-wrapper',[_c('template',{slot:"title"},[_vm._v("Dashboard")]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_vm._v(" Welcome ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }